import { ResetOfferRequestFlightItineraryState } from './resetOfferRequestFlightItinerary.types'

const initialState: ResetOfferRequestFlightItineraryState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
